// extracted by mini-css-extract-plugin
export default {"segmented":"SegmentedRadioGroup_segmented__RuPVh"};